import { createContext } from 'react';

const eppContext = createContext();

export default eppContext;
